import React from "react";
import { useLocation } from "react-router-dom";
import Footer from "./Footer";


export default function AppLayout({ children }) {
  const location = useLocation();

  // Optional: hide footer on admin login only
  const hideFooter = location.pathname === "/admin/login";

  return (
    <div className="h-screen flex flex-col bg-gray-50">
  
      {/* Main content */}
      <div className="flex-1">
        {children}
      </div>

      {/* Global Footer */}
      {!hideFooter && <Footer />}
    </div>
  );
}